module.exports = [
    'common',
    'dataContext',
    'applicationStateService',
    htsOtherSectionsDataService
];

function htsOtherSectionsDataService(
    common,
    dataContext,
    state
) {
    var service = {
        getAboutTheHtsSection: getAboutTheHtsSection,
        getHtsGeneralNotesSection: getHtsGeneralNotesSection,
        getHtsAppendicesSection: getHtsAppendicesSection,
        getNonChapterSection: getNonChapterSection,
        getHtsPdfFile: getHtsPdfFile
    };
    return service;

    function getAboutTheHtsSection() {
        return loadOtherSections().then(result => result[0]);
    }

    function getHtsGeneralNotesSection() {
        return loadOtherSections().then(result => result[1]);
    }

    function getHtsAppendicesSection() {
        return loadOtherSections().then(result => result[result.length - 1]);
    }

    function getHtsPdfFile(fileTitle) {
        var url = common.config.apiHosts.generic + '/hts/pdf/' + fileTitle + '?date=' + state.filter.date;
        return dataContext.getPdfAsObjectUrl(url);
    }

    function getNonChapterSection(sectionId) {
        switch (sectionId) {
            case 'about-the-hts':
                return getAboutTheHtsSection();
            case 'general-notes':
                return getHtsGeneralNotesSection();
            case 'appendices':
                return getHtsAppendicesSection();
            default:
                return Promise.resolve(null);
        }
    }

    function loadOtherSections() {
        var url = common.config.apiHosts.generic + '/hts/non-chapter-sections';
        return dataContext.get(url);
    }
}